module.exports = "<Tag>\n  Default\n  <Icon name=\"close\" size=\"extraSmall\" className=\"u-cursorPointer u-marginLeftTiny u-lineHeightReset\" />\n</Tag>;\n"